<template>
	<div>
		
		<div class="r-title">
			<img src="../../assets/imgs/news/news-title-bg.png" class="r-title-bg">
			<span style="z-index: 1;position: relative;">Followings</span>
		</div>
		
		<div style="display: flex;">
			<div class="btn-normal" :class="{ 'btn-normal-active': activebtn == 0 }" @click="activebtn = 0">Experts</div>
			<div class="btn-normal" :class="{ 'btn-normal-active': activebtn == 1 }" @click="activebtn = 1">Service Providers</div>
		</div>
		<div v-if="activebtn == 0">
			<div style="display: flex;margin-top: 1rem;padding: 1rem;border-radius: 0.5rem;" class="hover-up transition-normal"
						v-for="(item, expertindex) in expertdata" :key="expertindex">
				<div :style="{backgroundImage:'url('+item.avatar+')'}" class="avatar" style="cursor: pointer;" @click="expertboxshow(1, item)" ></div>
				<div style="background-color: #fff;">
					<div style="font-size: 1rem;font-weight: bold;cursor: pointer;" @click="expertboxshow(1, item)" >{{item.realName}}</div>
					<div style="margin-top: 1rem;cursor: pointer;" class="profile" @click="expertboxshow(1, item)" >{{item.profile}}</div>
					<!-- <div style="display: flex;justify-content: flex-end;color: #1E8F85;cursor: pointer;align-items: flex-end;margin-top: 1rem;" @click="unfollowexpert(item.id)">
						<span style="border-bottom: 4px solid #6AEBE3;">un follow</span>
					</div> -->
					<div style="display: flex;justify-content: flex-end;margin-top: 1rem;">
						<div style="color: #333;font-size: 0.8rem;display: flex;align-items: center;justify-content: center;border-radius: 3rem;padding: 0.4rem 0.7rem;
								font-weight: bold;width: 6rem;cursor: pointer;background-color: #D4F9F3;" @click="unfollowexpert(item.id)">UnFollow</div>
					</div>
				</div>
			</div>
				<div v-show="expertdata.length==0&&!expertloading" class="nodata-box">
					<img src="../../assets/imgs/nodata.svg" class="nodata-img">
				</div>
		</div>
		
		<div v-if="activebtn == 1">
			<div class="hover-up transition-normal fadeIn animated supplier" style="background-color: #fff;padding: 1rem;display: flex;margin: 1rem 0;border-radius: 1rem;"
					v-for="(item, index2) in supplierdata" :key="index2">
				<div :style="{backgroundImage: 'url('+item.coverImage+')'}" @click="tosupplierdetail(item)" class="main-img" style="cursor: pointer;"></div>
				<div style="display: flex;flex-direction: column;width: 100%;">
					<div style="cursor: pointer;" class="main-title" @click="tosupplierdetail(item)">{{item.providerName}}</div>
					<div style="display: flex;flex-wrap: wrap;cursor: pointer;" @click="tosupplierdetail(item)">
						<div v-for="(c, index3) in item.certifications" :key="index3" style="padding:0rem 0.5rem;border: 1px solid #D8D8D8;border-radius: 2rem;font-size: 0.5rem;
						display: flex;align-items: center;justify-content: center;margin-right: 0.5rem;margin-bottom: 0.5rem;">{{c.name}}</div>
					</div>
					<div style="font-size: 0.7rem;color: #666;cursor: pointer;" class="supplier-desc" @click="tosupplierdetail(item)">{{item.providerDescription}}</div>
					<div style="display: flex;justify-content: flex-end;margin-top: 1rem;">
						<div style="color: #333;font-size: 0.8rem;display: flex;align-items: center;justify-content: center;border-radius: 3rem;padding: 0.4rem 0.7rem;
								font-weight: bold;width: 6rem;cursor: pointer;" class="supplier-follow btn-lightgreen" @click="unfollowsupplier(item.id)">UnFollow</div>
					</div>
				</div>
			</div>
				<div v-show="supplierdata.length==0&&!supplierloading" class="nodata-box">
					<img src="../../assets/imgs/nodata.svg" class="nodata-img">
				</div>
		</div>
		
		
		<div style="position: fixed;left: 0;top: 0;width: 100vw;height: 100vh;z-index: 999;display: flex;align-items: center;justify-content: center;" v-if="expertbox==1">
			<div style="background-color: rgba(0, 0, 0, 0.9);width: 100%;height: 100%;position: absolute;z-index: 1;"></div>
			<div style="display: flex;z-index: 10" class="fadeInDown animated author-dialog">
				<div style="" class="author-dialog-left">
					<!-- <img :src="exceptitem.avatar" style="width: 100%;height: 13.5rem;"> -->
					<div :style="{backgroundImage: 'url('+exceptitem.avatar+')'}" style="" class="author-dialog-img"></div>
					<div class="author-dialog-left-name">
						<div style="font-size: 1.5rem;color: #000;font-weight: bold;margin-top: 1rem;">{{exceptitem.realName}}</div>
						<div style="display: flex;align-items: center;justify-content: center;width: 8rem;height: 2.5rem;margin-top: 2rem;
								border-radius: 2rem;cursor: pointer;background-color: #fff;color: #000" @click="unfollowexpert(exceptitem.id)">UnFollow</div>
					</div>
				</div>
				<div style="" class="author-dialog-right">
					<div style="display: flex;flex-direction: column;overflow: scroll;" class="exceptbox">
						<div style="color: #000;font-size: 1.5rem;font-weight: bold;;"><span style="border-bottom: 0.2rem solid #31FFDA;">Personal profile</span></div>
						<div style="color: #707070;font-weight: 400;margin-top: 1rem;font-size: 0.7rem;">{{exceptitem.profile}}</div>
						
						<div style="color: #000;font-size: 1.5rem;font-weight: bold;margin-top: 1rem" v-if="exceptitem.honoour">
							<span style="border-bottom: 0.2rem solid #31FFDA;">Industry honor</span>
						</div>
						<div style="display: flex;margin-top: 1rem;flex-wrap: wrap;">
							<img :src="img" style="width: 6rem;height: 7.2rem;margin-right: 1rem;margin-bottom: 0.2rem;" v-for="(img, index4) in exceptitem.honour">
						</div>
					</div>
					<div style="position: absolute;right: 1rem;top: 1rem;"><img src="../../assets/imgs/box-close.png" style="width: 2rem;height: 2rem;cursor: pointer;" @click="expertboxshow(0, {})"></div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
		export default {
			data() {
				return {
					type:0,
					expertdata:[],
					activebtn:0,
					supplierdata:[],
					
					expertbox:0,
					
					expertloading:true,
					supplierloading:true
				}
			},
			components: {
			},
			methods: {
				tosupplierdetail(item){
					this.$router.push({name:'supplierdetail',query:{id:item.id}})
				},
				unfollowsupplier(id){
					let params = {
						providerId: id
					}
					this.request({
						method: 'post',
						url: '/gci/user/provider/follow',
						data:params
					}).then(res => {
						this.getsupplierdata()
					}).catch(error => {
						console.error(error.response)
					})
				},
				unfollowexpert(id){
					let params = {
						expertId: id
					}
					this.request({
						method: 'post',
						url: '/gci/user/expert/follow',
						data:params
					}).then(res => {
						this.expertbox = 0
						this.getexpertdata()
					}).catch(error => {
						console.error(error.response)
					})
				},
				getexpertdata(){
					this.expertloading = true
					this.request({
						method: 'get',
						url: '/gci/user/expert/follow/list',
					}).then(res => {
						this.expertdata = res.data.items
						console.info(this.expertdata)
						this.expertloading = false
					}).catch(error => {
						console.error(error.response)
					})
				},
				getsupplierdata(){
					this.supplierloading = true
					this.request({
						method: 'get',
						url: '/gci/user/provider/follow/list',
					}).then(res => {
						this.supplierdata = res.data.items
						this.supplierloading = false
					}).catch(error => {
						console.error(error.response)
					})
				},
				expertboxshow(i, item){
					this.expertbox = i
					this.exceptitem = item
				},
			},
			mounted() {
				this.type = this.$route.query.type
				this.getexpertdata()
				this.getsupplierdata()
			}
		}
</script>

<style lang="scss" scoped>
	.change-btn{
		display: flex;align-items: center;justify-content: center;padding: 0.5rem 1rem;border: 1px solid #999;margin-right: 0.5rem;cursor: pointer;
		border-radius: 0.2rem;
				font-weight: bold;
	}
	.active-btn{
		background-color: #31ffda;color: #333;border: 1px solid transparent;
	}
	.r-title{
		height: 3rem;
		font-size: 1.5rem;
		font-weight: bold;
		position: relative;
		.r-title-bg{
			width: 13rem;position: absolute;left: -0.5rem;top: -2rem
		}
	}
	
	.avatar{
		background-position: center;background-repeat: no-repeat;background-size: cover;border-radius: 0.5rem;height: 13rem;min-width: 10rem;margin-right: 1rem;
	}
	.profile{
			margin-top: 1rem;
			display: -webkit-box;
			-webkit-line-clamp: 4;
			-webkit-box-orient: vertical;
			text-overflow: ellipsis;
			overflow: hidden;
	}
	.main-img{
		background-position: center;
		background-size: cover;
		background-repeat: no-repeat;
		min-width: 10rem;
		height: 10rem;
		margin-right: 1rem;border-radius: 0.2rem;
	}
	.main-title{
		color: #000;font-size: 1.5rem;font-weight: bold;margin-bottom: 0.5rem;
	}
		.supplier-desc{
			display: -webkit-box;
			-webkit-line-clamp: 3;
			-webkit-box-orient: vertical;
			text-overflow: ellipsis;
			overflow: hidden;
		}
	
	.author-dialog{
		
		.author-dialog-left{
			border-radius: 1.25rem 0 0 1.25rem;background: #31FFDA;width: 15rem;height: 30rem;display: flex;align-items: center;padding: 2rem;flex-direction: column;
			
			.author-dialog-left-name{
				display: flex;flex-direction: column;align-items: center;
			}
			.author-dialog-img{
				background-size:cover; background-repeat: no-repeat;background-position: top center ;width: 100%;height: 13.5rem;
			}
		}
		.author-dialog-right{
			border-radius: 0 1.25rem 1.25rem 0;background-color: #fff;width: 35rem;height: 30rem;display: flex;padding: 1.5rem;
		}
	}
	.expert-box-realname{
		color: #333;font-size: 1rem;font-weight: bold;text-align: center;
	}
	.expert-dark{background-color: rgba(82, 82, 82, 0.46);align-items: center;justify-content: center;width: calc(100% - 30px);height: 20rem;position: absolute;left: 15px;top: 0;display: none;border-radius: 0.2rem}
	.expert-box{overflow:hidden;width: 100%;margin-bottom: 2rem;border-radius: 0.2rem;display: flex;justify-content: center;flex-direction: column;align-items: center;}
	.expert-box:hover{
		.expert-dark{display: flex;}
		.expert-box-realname{color: #16E1BD;}
	}
	.expert-img{
		background-position: center top;background-size: cover;background-repeat: no-repeat;
		width: 100%;height:20rem;z-index: -1;
	}
	.expert-subtitle{
		font-size: 1.2rem;color: #8C8C8C;font-weight: 400;margin-top: 1rem;text-align: center;
	}
	.title-text{
		margin-left:-2rem
	}
	.expert-title{
		display:flex;align-items: flex-start;justify-content: center;font-weight: 900;color: #333;font-size: 3rem;margin-top: 6rem;
	}
	.title-icon{
		width: 3rem;height: 3rem;
	}
	.exceptbox::-webkit-scrollbar {display:none}
	@media (max-width:767px) {
		.avatar{
			min-width: 8rem;
			height: 10rem;
		}
		.author-dialog{
			margin: 1rem;
			flex-direction: column;
			.author-dialog-left{
				width: 100%;
				height: 17rem;
				flex-direction: row;
				border-radius: 1.25rem 1.25rem 0 0 ;
				.author-dialog-left-name{
					margin-left: 1rem;
				}
				.author-dialog-img{
					height: 11rem;
				}
			}
			.author-dialog-right{
				border-radius: 0 0 1.25rem 1.25rem;
				width: 100%;
				height: 23rem;
			}
		}
		
		.main-title{
			display: -webkit-box;
			-webkit-line-clamp: 2;
			-webkit-box-orient: vertical;
			text-overflow: ellipsis;
			overflow: hidden;
		}
		.main-img{
			min-width: 100%;height: 10rem;margin-bottom: 1rem;
		}
		.supplier-follow{
			display: none !important;
		}
		
		.expert-box{
			flex: 0 0 100%;
			max-width: 100%;
		}
		.dialog-box{
			width: 20rem;
		}
		.supplier{
			flex-direction: column;
		}
	}
</style>